import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics, logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyCKkpEEY3PwIXyGXGBkIUp0eLfyoMzjs1Y",
  authDomain: "sobia-pos-locator.firebaseapp.com",
  projectId: "sobia-pos-locator",
  storageBucket: "sobia-pos-locator.firebasestorage.app",
  messagingSenderId: "24680897747",
  appId: "1:24680897747:web:663cbb3a3a7059575d8826",
  measurementId: "G-SNFM4PQ1BY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);

// Analytics helper function
export const logAnalyticsEvent = (eventName, eventParams = {}) => {
  try {
    logEvent(analytics, eventName, eventParams);
  } catch (error) {
    console.error('Analytics error:', error);
  }
};

export default app; 